import React from "react";
import { PublicShell } from "@/components/PublicNav";
import { Heart, Target, Users } from "lucide-react";

export const About = () => (
  <PublicShell>
    <section className="zq-hero-bg">
      <div className="max-w-5xl mx-auto px-5 md:px-8 py-16 md:py-20">
        <span className="zq-pill zq-pill-orange">About ZaykaQR</span>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mt-4">
          Built by Indians, for Indian restaurants.
        </h1>
        <p className="text-zq-muted mt-5 text-base max-w-3xl">
          India has over 75 lakh restaurants — from humble roadside dhabas to
          elegant fine-dining spaces. Yet most of them still rely on printed
          menus, handwritten order slips, and word-of-mouth marketing. Every
          time a price changes, a new menu gets printed. Every time a dish runs
          out, a customer gets disappointed. We saw this problem firsthand. A
          restaurant owner spending ₹3,000 every few months on new menus. A
          dhaba losing orders because customers didn't know what was available.
          A café missing Google reviews because there was no easy way to ask
          customers to leave one. So we built ZaykaQR — a complete digital menu
          system designed specifically for Indian restaurants. One QR code. One
          scan. Your entire restaurant — online, real-time, and commission-free.
        </p>
      </div>
    </section>

    <section className="zq-section bg-white">
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-6">
        {[
          {
            icon: Heart,
            t: "Our Mission",
            d: "Help every Indian restaurant — from a chai stall to a fine-dine — own their digital experience without paying commissions.",
          },
          {
            icon: Target,
            t: "Our Belief",
            d: "Owning your customer relationship is everything. WhatsApp + QR + Loyalty makes that possible.",
          },
          {
            icon: Users,
            t: "Our Team",
            d: "A small team of food lovers, designers and engineers building from Ahmedabad, Mumbai and Bengaluru.",
          },
        ].map((b, i) => (
          <div key={i} className="zq-card p-6">
            <b.icon className="text-zq-orange" size={28} />
            <h3 className="mt-3 text-lg font-semibold">{b.t}</h3>
            <p className="text-zq-muted mt-2 text-sm">{b.d}</p>
          </div>
        ))}
      </div>
    </section>
  </PublicShell>
);
